'use client'

// This is the only place in the codebase where we should import useLayoutEffect directly from React
// eslint-disable-next-line no-restricted-imports
import { useLayoutEffect as useReactLayoutEffect, useEffect } from 'react'

/**
 * Employ `useEffect` on the server to prevent warnings, otherwise employ `useLayoutEffect`
 *
 * @see https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */
const useIsomorphicLayoutEffect: (effect: React.EffectCallback, deps?: React.DependencyList | undefined) => void =
    typeof window !== 'undefined' ? useReactLayoutEffect : useEffect

// Ensure the name used in components is useLayoutEffect so that ESLint rules will apply to it like normal
export default { useLayoutEffect: useIsomorphicLayoutEffect }
